import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyEnvironmentTypesStore from "./property-environment-types.store";
import { IPropertyEnvironmentPointMapList } from "../../../../models/property/property-environment-point.model";
import { IPropertyEnvironmentPicture } from "../../../../models/property";

const environmentActions = <ActionTree<IPropertyEditState, any>>{
    [propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT_POINT]: ({ getters, commit }, param: number) => {
        return getters.service[propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT_POINT](param)
            .then((response: IPropertyEnvironmentPointMapList) => {
                commit(propertyEnvironmentTypesStore.Set.LIST_PROPERTY_ENVIRONMENT_POINT, response)
            })
    },
    [propertyEnvironmentTypesStore.Get.LIST_PICTURE_PROPERTY_ENVIRONMENT]: ({ getters, commit }, param: number) => {
        return getters.service[propertyEnvironmentTypesStore.Get.LIST_PICTURE_PROPERTY_ENVIRONMENT](param)
            .then((response: IPropertyEnvironmentPicture) => {
                // commit(propertyEnvironmentTypesStore.Set.LIST_PICTURE_PROPERTY_ENVIRONMENT,response)
                return Promise.resolve(response)
            })
    },
    [propertyEnvironmentTypesStore.Get.URL_PICTURE_FROM_STORAGE]: ({ getters, commit }, param: IPropertyEnvironmentPicture) => {
        if (param.OriginalPublishUrl)
        {
            commit(propertyEnvironmentTypesStore.Set.URL_PICTURE_FROM_STORAGE, {
                PictureNumber: param.PictureNumber,
                UrlPicture: param.OriginalPublishUrl
            });
            return Promise.resolve({ URL: param.OriginalPublishUrl })
        }

        return getters.service[propertyEnvironmentTypesStore.Get.URL_PICTURE_FROM_STORAGE](param.OriginalUrl)
            .then((response: { URL: string }) => {
                const payload = {
                    PictureNumber: param.PictureNumber,
                    UrlPicture: response.URL
                }
                commit(propertyEnvironmentTypesStore.Set.URL_PICTURE_FROM_STORAGE, payload)
            })
    }
}

export default environmentActions;